import type { HeaderGroup, Row } from '@tanstack/react-table';

const toCSS = ({
  size,
  minSize,
  maxSize,
}: {
  size?: number | string;
  minSize?: number | string;
  maxSize?: number | string;
}) => (Number.isNaN(size) ? '1fr' : `${size}px`);

/**
 * Generates the CSS grid template columns for a table row.
 *
 * @param row - The row instance from the table.
 * @param headerGroup - The headers instance from the table.
 */
export const getGridTemplateColumns = ({
  row,
  headerGroup,
}: {
  row?: Row<any>;
  headerGroup?: HeaderGroup<any>;
}) => {
  if (row) {
    return row
      .getVisibleCells()
      .map(cell =>
        toCSS({
          size: cell.column.getSize(),
          minSize: cell.column.columnDef.minSize,
          maxSize: cell.column.columnDef.maxSize,
        }),
      )
      .join(' ');
  }
  if (headerGroup) {
    return headerGroup.headers
      .map(header =>
        toCSS({
          size: header.getSize(),
          minSize: header.column.columnDef.minSize,
          maxSize: header.column.columnDef.maxSize,
        }),
      )
      .join(' ');
  }

  return '1fr';
};
